import "./SignIn.css";
import axios from "axios";
import React, { useContext, useState } from "react";
import LoadingAction from "../../../themes/LoadingAction/LoadingAction";
import Auth from "../Auth/Auth";
import * as links from "../../../utils/links";
import signin from "../../../assets/images/stronda_telemetria.png";
import { AuthContext } from "../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { NotificationContainer } from "react-notifications";

const initialDataSignIn = {
  email: "",
  password: "",
};

const initErrorField = {
  email: undefined,
  password: undefined,
};

const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const SignIn = () => {
  const { setDataUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const [dataAuth, setDataSingUp] = useState({ ...initialDataSignIn });
  const [error, setError] = useState(null);
  const [errorField, setErrorField] = useState({ ...initErrorField });
  const [isLoading, setIsLoading] = useState(false);

  const loginAt = (endpoint) =>
    axios.post(`${process.env.REACT_APP_SERVIDOR}${endpoint}`, {
      senha: dataAuth.password,
      email: dataAuth.email.trim(),
    });

  const onsubmit = async () => {
    let dataErrorField = {};

    if (dataAuth.email.trim() === "") {
      dataErrorField.email = "Email obrigatório.";
    } else if (!validateEmail(dataAuth.email.trim())) {
      dataErrorField.email = "Email inválido.";
    }

    if (dataAuth.password.trim() === "") {
      dataErrorField.password = "Senha obrigatória";
    } else if (dataAuth.password.trim().length < 6) {
      dataErrorField.password = "Senha tem que ter no mínimo 6 dígitos.";
    }

    if (Object.keys(dataErrorField).length !== 0) {
      setErrorField((prev) => ({ ...prev, ...dataErrorField }));
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      let response;
      try {
        response = await loginAt("/login-cliente");
      } catch (clientError) {
        response = await loginAt("/login-pessoa");
      }

      if (response?.status !== 200 || !response?.data?.key) {
        throw new Error("LOGIN_INVALIDO");
      }

      const userData = { ...response.data };
      setDataUser(userData);
      setDataSingUp({ ...initialDataSignIn });

      /* Todo login começa na primeira opção do menu.
         Depois disso o React Router mantém a rota atual quando a página é atualizada. */
      if (userData.key === "ADMIN") {
        navigate(links.ADMIN_CENTRAL, { replace: true });
      } else {
        navigate(links.CLIENTE_VISAO_GERAL, { replace: true });
      }
    } catch (err) {
      if (!err?.response) {
        setError("Não foi possível comunicar com o servidor. Tente novamente.");
      } else {
        setError("E-mail ou senha inválidos.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <NotificationContainer />
      {isLoading && <LoadingAction />}
      <Auth
        authTitle={"Login"}
        authDescription={"Acesso único para administrador e empresas."}
        authFields={[
          {
            label: "E-mail",
            placeholder: "Digite seu e-mail",
            name: "email",
            value: dataAuth?.email ?? "",
            type: "text",
            setField: (value) => {
              setDataSingUp((prev) => ({ ...prev, email: value }));
              setErrorField((prev) => ({ ...prev, email: undefined }));
            },
            error: errorField?.email ?? "",
          },
          {
            label: "Senha",
            placeholder: "Digite sua senha",
            name: "password",
            value: dataAuth?.password ?? "",
            type: "password",
            setField: (value) => {
              setDataSingUp((prev) => ({ ...prev, password: value }));
              setErrorField((prev) => ({ ...prev, password: undefined }));
            },
            error: errorField?.password ?? "",
          },
        ]}
        authSubmit={"Entrar"}
        textImage={"STRONDA MUSIC TELEMETRIA"}
        authImage={signin}
        onsubmit={onsubmit}
        errorMessage={error ?? ""}
        isSignIn={true}
      />
    </>
  );
};

export default SignIn;
